import { render, staticRenderFns } from "./newPolicyMessage.vue?vue&type=template&id=aab430c6&scoped=true"
import script from "./newPolicyMessage.vue?vue&type=script&lang=js"
export * from "./newPolicyMessage.vue?vue&type=script&lang=js"
import style0 from "./newPolicyMessage.vue?vue&type=style&index=0&id=aab430c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aab430c6",
  null
  
)

export default component.exports